module.exports = __webpack_public_path__ + "static/media/galleryGT (10).bd548b1c.jpg";